<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M64.6862 16.6737C64.6862 24.8592 57.9675 31.4949 49.6794 31.4949C41.3914 31.4949 34.6726 24.8592 34.6726 16.6737" stroke="#070809" stroke-width="4"/>
<path d="M14 46V17H86V46H76V83H24V46H14Z" stroke="black" stroke-width="4"/>
</svg>

</template>
